import styles from "./Button.module.css";

export default function Button({ children, variant = "default", ...props }) {
  const getButtonClass = () => {
    switch (variant) {
      case "gold":
        return styles.buttonGold;
      case "light":
        return styles.buttonLight;
      case "outlined":
        return styles.buttonLight;
      default:
        return styles.button;
    }
  };

  return (
    <button className={getButtonClass()} {...props}>
      {children}
    </button>
  );
}
